export const sanitizeText = (text) => {
    return text.trim().replace(/\s+/g, " ");
};
